import { render, staticRenderFns } from "./FormChoiceField.vue?vue&type=template&id=1ae8b054&scoped=true&"
import script from "./FormChoiceField.vue?vue&type=script&lang=ts&"
export * from "./FormChoiceField.vue?vue&type=script&lang=ts&"
import style0 from "./FormChoiceField.vue?vue&type=style&index=0&id=1ae8b054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae8b054",
  null
  
)

export default component.exports